import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { RelatedUserApp, Tile } from '../models';
import { HttpHeaders } from '@angular/common/http';

@Injectable()
export class AppService {

    _api$: Subject<string> = <Subject<string>>new Subject();
    get api$() { return this._api$.asObservable(); }

    get Headers(): HttpHeaders { return new HttpHeaders({ 'api-key': '89ED3525339D3D529DDBF32C6712D718' }) };

    public static AppLookupTable = {
        'Accounts': { label: 'Accounts', route: '/company/accounts', icon: 'far fa-building fa-3x', color: 'other-blue' },
        'Activities': { label: 'Activities', route: '/activities', icon: 'rowing', color: 'green' },
        'Analytics': { label: 'Analytics', route: '/analytics', icon: 'fas fa-search-dollar fa-3x', color: 'orange' },
        'Branches': { label: 'Locations', route: '/company/branches', icon: 'fas fa-store-alt fa-3x', color: 'purple' },
        'CallReports': { label: 'Call Reports', route: '/callreports/callreports', icon: 'fab fa-telegram fa-3x', color: 'other-purple' },
        'Contacts': { label: 'Contacts', route: '/contacts/contacts', icon: 'far fa-address-book fa-3x', color: 'orange' },
        'Help': { label: 'Help', route: '/help', icon: 'far fa-question-circle fa-3x', color: 'red' },
        'Invoices': { label: 'Invoices', route: '/invoices/invoices', icon: 'fas fa-file-invoice', color: 'blue' },
        'Inventory': { label: 'Inventory', route: '/inventory/inventorystatus', icon: 'fas fa-box-open', color: 'blue' },
        'MarketingRequests': { label: 'Flyer Requests', route: '/marketingrequests', icon: 'fas fa-ad', color: 'cyan' },
        'Photos': { label: 'Photos', route: '/company/photos', icon: 'fas fa-images', color: 'dark-khaki' },
        'PriceRequests': { label: 'Price Requests', route: '/pricerequests', icon: 'fas fa-cart-arrow-down', color: 'other-green' },
        'Promotions': { label: 'Promotions', route: '/promotions', icon: 'fas fa-shopping-basket', color: 'light-slategray' },
        'Quarterback': { label: 'Quarterback', route: '/quarterback/quarterback', icon: 'monetization_on', color: 'other-green' },
        'RGA': { label: 'RGA', route: '/rgas', icon: 'fas fa-truck-loading', color: 'other-blue' },
        'Recap': { label: 'Weekly Recap', route: '/weeklyrecaps/weekly-summaries', icon: 'autorenew', color: 'light-green' },
        'Reports': { label: 'Reports', route: '/reports', icon: 'fas fa-file-pdf fa-3x', color: 'grey' },
        'Restock': { label: 'Restock', route: '/restock/restockorders', icon: 'fab fa-stack-overflow fa-3x', color: 'green' },
        'SampleRequests': { label: 'Service Requests', route: '/servicerequests', icon: 'fas fa-barcode', color: 'light-slategray' },
        'Security': { label: 'Security', route: '/security/security', icon: 'security', color: 'grey' },
        'ShipTo': { label: 'Ship To', route: '/company/ship-to', icon: 'edit_location', color: 'orange' },
        'Tallysheet': { label: 'Tallysheet', route: '/quarterback/tallysheets', icon: 'monetization_on', color: 'other-green' },
        'Tech Support': { label: 'Tech Support', route: '/techsupport', icon: 'build', color: 'other-blue' },
        'Utilities': { label: 'Utilities', route: '/utilities/utilities', icon: 'build', color: 'grey' },
    };

    constructor() {
    }

    public appLookup(apps: RelatedUserApp[]): Tile[] {
        var retval: Tile[] = apps.map(x => {
            if (AppService.AppLookupTable[x.name]) {
                var app = AppService.AppLookupTable[x.name];
                app.userApp_Id = x.userApp_Id;
                app.displayIndex = x.displayIndex;
                return app;
            }
        });

        retval = retval.sort((a: Tile, b: Tile) => {
            if (a.displayIndex < b.displayIndex)
                return -1;
            else if (a.displayIndex > b.displayIndex)
                return 1;
            else
                return (a.label < b.label) ? -1 : (a.label > b.label) ? 1 : 0;
        });

        return retval.filter(t => t);
    }
}